export const capitalizeReason = (reason: string): string => {
    return reason
      ?.trim()
      .toLowerCase()
      .split(' ')
      .filter(Boolean)
      .map(
        (word: string) => word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(' ');
  };